//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect, useCallback } from 'react';
import { useStore } from '../../store/store';
import { useDispatch } from 'react-redux';
import { processEmail } from 'src/store/profile/actions';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { reInit as reInitRemoteConfig } from '@web-solutions/core/store/remote-config/actions';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import { Email, domains } from '@smastrom/react-email-autocomplete';
import './style.scss';
import getLocale from 'src/localization/get-locale';
import { validateEmail } from 'src/onboarding/helpers/validateEmail';
import { useRemoteConfig } from '@web-solutions/base-app/hooks/use-remote-config';
import axios from 'axios';
import { getEnvUrl } from 'src/onboarding/helpers/getEnvUrl';
import { applyFoodzeeAuthTokens } from 'src/onboarding/helpers/applyFoodzeeAuthTokens';
import { getLocalizedText } from 'core/utils/localized';

interface UserPayload {
  email: string;
}

function Page() {
  const email = useStore((state) => state.email);
  const setEmail = useStore((state) => state.setEmail);
  const setUserId = useStore((state) => state.setUserId);
  const dispatch = useDispatch();
  const { onNext, onPrev, currentIndex } = useNav();
  const setPage = useStore((state) => state.setPage);
  const { email: emailRemote, paymentSystem } = useRemoteConfig();
  const locale = getLocale();
  const { apiBaseUrl } = getEnvUrl();
  const isStripePayment = paymentSystem === 'stripe';

  const [errorMessage, setErrorMessage] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [keyboardOpen, setKeyboardOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const baseList = [
    'gmail.com',
    'yahoo.com',
    'hotmail.com',
    'outlook.com',
    'icloud.com',
    'aol.com',
  ];

  const isIOS = () => {
    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
  };

  useEffect(() => {
    const preventScroll = (e) => {
      const dropdown = document.querySelector('.custom-email-dropdown');
      if (!dropdown || !dropdown.contains(e.target)) {
        e.preventDefault();
      }
    };

    if (isDropdownOpen || keyboardOpen) {
      document.body.classList.add('no-scroll');
      document.body.addEventListener('touchmove', preventScroll, { passive: false });
    } else {
      document.body.classList.remove('no-scroll');
      document.body.removeEventListener('touchmove', preventScroll);
    }

    return () => {
      document.body.classList.remove('no-scroll');
      document.body.removeEventListener('touchmove', preventScroll);
    };
  }, [isDropdownOpen, keyboardOpen]);

  useEffect(() => {
    const preventScroll = (e) => {
      const dropdown = document.querySelector('.custom-email-dropdown');
      if (!dropdown || !dropdown.contains(e.target)) {
        e.preventDefault();
      }
    };

    if (isDropdownOpen || keyboardOpen) {
      document.body.classList.add('no-scroll');
      document.body.addEventListener('touchmove', preventScroll, { passive: false });
    } else {
      document.body.classList.remove('no-scroll');
      document.body.removeEventListener('touchmove', preventScroll);
    }

    return () => {
      document.body.classList.remove('no-scroll');
      document.body.removeEventListener('touchmove', preventScroll);
    };
  }, [isDropdownOpen, keyboardOpen]);

  useEffect(() => {
    const input = document.getElementById('email-field');
    if (!input || !isIOS()) return;

    let resizeTimeout: number | null = null;

    const updateButtonPosition = (keyboardHeight: number) => {
      const buttonElement = document.querySelector('.next-wrapper');
      const buttonBg = document.querySelector('.button-white-bg');

      const bottomValue = keyboardHeight > 100 ? `${keyboardHeight}px` : '0px';

      if (buttonElement) buttonElement.style.bottom = bottomValue;
      if (buttonBg) buttonBg.style.bottom = bottomValue;
    };

    const handleViewportResize = () => {
      if (!window.visualViewport) return;

      const keyboardHeight = window.innerHeight - window.visualViewport.height;
      const keyboardNowOpen = keyboardHeight > 150;

      setKeyboardOpen(keyboardNowOpen);
      updateButtonPosition(keyboardHeight);
    };

    const onFocus = () => {
      setKeyboardOpen(true);
      handleViewportResize();
      requestAnimationFrame(() => {
        setTimeout(() => handleViewportResize(), 200);
      });
    };

    const onBlur = () => {
      setKeyboardOpen(false);
      updateButtonPosition(0);
    };

    const onResize = () => {
      if (resizeTimeout) clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handleViewportResize, 50);
    };

    input.addEventListener('focus', onFocus);
    input.addEventListener('blur', onBlur);
    window.visualViewport?.addEventListener('resize', onResize);

    return () => {
      input.removeEventListener('focus', onFocus);
      input.removeEventListener('blur', onBlur);
      window.visualViewport?.removeEventListener('resize', onResize);
      if (resizeTimeout) clearTimeout(resizeTimeout);
    };
  }, []);

  useEffect(() => {
    if (!email) {
      setErrorMessage('');
      setIsValid(false);
    } else if (!validateEmail(email)) {
      setErrorMessage(t('onboarding.email.errorMessage'));
      setIsValid(false);
    } else {
      setErrorMessage('');
      setIsValid(true);
    }
  }, [email]);

  const handleSubmit = useCallback(
    async (value) => {
      if (!isValid || isSubmitting) return;

      setIsSubmitting(true);
      let shouldProceed = false;

      // @ts-ignore
      window.fbq('track', 'CompleteRegistration');
      // @ts-ignore
      window.ttq?.track?.('CompleteRegistration');

      await dispatch(processEmail(value));
      await dispatch(reInitRemoteConfig());

      try {
        const payload: UserPayload = {
          email: value,
        };

        const response = await axios.post(`${apiBaseUrl}/v2/user`, payload);

        if (response.status === 201) {
          setUserId(response.data.uid);
          const billingInit = applyFoodzeeAuthTokens(response.data, dispatch, { reinitBilling: true, paymentSystem });

          if (isStripePayment && billingInit && typeof (billingInit as any).then === 'function') {
            await billingInit;
          }

          shouldProceed = true;
        }
      } catch (error) {
        console.error('Error creating user:', error);
      } finally {
        if (shouldProceed) {
          onNext();
        }

        setIsSubmitting(false);
      }
    },
    [apiBaseUrl, dispatch, isStripePayment, isSubmitting, isValid, onNext, paymentSystem, setUserId]
  );

  const getPaddingLeft = (email: string | undefined, locale: string): number => {
    if (email?.length >= 1) return 0;

    switch (locale) {
      case 'en':
      case 'tr':
        return 80;
      // case 'it':
      // case 'cs': return 60;
      // case 'de':
      // case 'id':
      // case 'fr':
      // case 'pt': return 45;
      // case 'es':  return 40;
      default:
        return 80;
    }
  };

  return (
    <div className='page'>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className='wrapper-info'>
        <Title tag='h2'>{getLocalizedText(emailRemote.title, locale)}</Title>
        <Text size='m' medium className='description'>
          {getLocalizedText(emailRemote.subTitle, locale)}
        </Text>
      </div>

      <div className='controls email'>
        <Email
          id='email-field'
          value={email}
          onChange={setEmail}
          placeholder={t('onboarding.email.placeholder')}
          autoFocus
          baseList={baseList}
          refineList={domains}
          classNames={{
            wrapper: 'custom-email-wrapper',
            dropdown: `custom-email-dropdown ${keyboardOpen ? 'keyboard-open' : ''}`,
            input: 'custom-email-input',
            suggestion: 'custom-email-suggestion',
            domain: 'custom-email-domain',
          }}
          style={{
            textAlign: (email?.length || 0) >= 1 ? 'center' : 'left',
            caretColor: 'black',
            paddingLeft: getPaddingLeft(email, locale),
          }}
        />
        <Caption size='m' className='error-message' style={{ margin: 0 }}>
          {errorMessage}
        </Caption>
        <span className='info'>
          <span className='top-info'>{t('onboarding.email.topInfo')}</span>
          <span className='bottom-info'>
            <a onClick={() => setPage('privacy-policy')}>{t('onboarding.email.privacyPolicy')}</a>
            <span className='bottom-info-devider'>&</span>
            <a onClick={() => setPage('terms-of-use')}>{t('onboarding.email.TermofUse')}</a>
          </span>
        </span>
      </div>
      <div className={`button-white-bg ${keyboardOpen && isIOS() ? 'keyboard-open' : ''}`}></div>
      <div className={`next-wrapper ${keyboardOpen && isIOS() ? 'keyboard-open' : ''}`}>
        <Button
          className={!isValid || isSubmitting ? 'disabled' : ''}
          title={t('onboarding.email.continue')}
          onClick={() => {
            if (!isValid || isSubmitting) return;
            handleSubmit(email);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'email',
              answer: email,
            });

            gtag('event', 'conversion', {
              send_to: 'AW-17149973324/cDa6CIPlt_0aEMym3_E_',
              value: 1.0,
              currency: 'USD',
            });
          }}
        />
      </div>
    </div>
  );
}

export default Page;
